import React from "react";
import { useModal } from "../contexts/modal";
import { Button } from "@heroui/button";
export default function SuccessModal({ description }: { description: string }) {
  const { closeModal } = useModal();
  return (
    <>
      <div className="flex w-full flex-col items-center justify-center p-5">
        <span className="icon-icon11 text-[5rem] text-[#258966]" />
        <h1 className="">{description}</h1>
      </div>
      <Button className="bg-[#258966]" onPress={closeModal}>
        Yes
      </Button>
    </>
  );
}
